// extracted by mini-css-extract-plugin
export default {"about__picture":"style_about__picture__gdbYC","about__image":"style_about__image__7Adpx","about__text":"style_about__text__Gl1Py"};